import React from 'react';
import { createPortal } from 'react-dom';
import { Box } from '../Box/Box.es.js';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { isBrowser } from '../../utils/dom.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Portal = forwardRef((props, ref) => {
  var _b;
  const _a = props, { children, isDisabled = false, containerRef } = _a, rest = __objRest(_a, ["children", "isDisabled", "containerRef"]);
  const hostElement = (_b = containerRef == null ? void 0 : containerRef.current) != null ? _b : isBrowser ? document == null ? void 0 : document.body : void 0;
  const [, forceUpdate] = React.useState({});
  useEnhancedEffect(() => {
    forceUpdate({});
  }, []);
  if (isDisabled) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  if (hostElement) {
    return createPortal(/* @__PURE__ */ React.createElement(Box, __spreadValues({
      ref
    }, rest), children), hostElement);
  }
  return null;
});
Portal.defaultProps = {
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1
};

export { Portal };
//# sourceMappingURL=Portal.es.js.map
